import Navbar from '../components/header/Navbar';
import Footer from '../components/Footer';
import Populer from '../components/community/PopularPhotos'
import NearKoala from '../components/community/KoalaNearYou'
import Story from '../components/community/PhotoStories'

export default function CommunityPage() {
  return (
    <>
      <Navbar />
      <NearKoala />
      <Story />
      <Populer /> 
      <Footer /> 
    </>
  );
}